import { Component, ViewChild, Output, EventEmitter, Input, SimpleChanges, AfterViewInit, OnInit } from "@angular/core"
import { FormControl } from "@angular/forms"
import { Observable } from "rxjs"
import { map, startWith } from "rxjs/operators"
import { MapService } from "src/app/services/map.service"
import { ITALY_BOUNDS } from "src/configs/map_configuration"
import { pageConfiguration } from "src/configs/page_configuration"

@Component({
	selector: "app-search-place",
	templateUrl: "./search-place.component.html",
	styleUrls: ["./search-place.component.scss"]
})
export class SearchPlaceComponent implements OnInit, AfterViewInit {
	public mapOptions: google.maps.places.AutocompleteOptions = {
		bounds: ITALY_BOUNDS,
		types: ["geocode"], // address , regions, cities,
		strictBounds: true,
		componentRestrictions: { country: "it" }
	}
	public mapCityOptions: google.maps.places.AutocompleteOptions = {
		types: ["(cities)"], // address , regions, cities,
		componentRestrictions: { country: "it" }
	}
	autocomplete: google.maps.places.Autocomplete
	public placeValue: any = ""
	public geocoder = new google.maps.Geocoder()
	private selectedPlace: any
	public selectedCluster: any
	public selectedPop: any
	@Input() searchModes: any[]
	@Input() actualSearchMode: string
	@Input() popsAutocompleteList: any[]
	@Input() options: string[] = []
	@Output() onSelectedAddress: EventEmitter<any> = new EventEmitter()
	@Output() onSelectedCity: EventEmitter<any> = new EventEmitter()
	@Output() onSelectedCluster: EventEmitter<any> = new EventEmitter()
	@Output() onSelectedPop: EventEmitter<any> = new EventEmitter()
	@Output() onReset: EventEmitter<any> = new EventEmitter()
	@Output() onSelectedId: EventEmitter<any> = new EventEmitter()
	@Output() onSwitchSearchMode: EventEmitter<string> = new EventEmitter()
	@ViewChild("searchTextField", { static: true }) searchTextField: any
	private init = true
	myControl = new FormControl()
	popControl = new FormControl()
	clusterOptions: Observable<any[]>
	popPcnOptions: Observable<any[]>

	constructor(public mapService: MapService) {}

	ngOnInit() {
		this.clusterOptions = this.myControl.valueChanges.pipe(
			startWith(""),
			map(value => this._filter(value))
		)
	}

	ngAfterViewInit() {
		if (this.init) {
			this.determineSearchMode()
			this.init = false
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.actualSearchMode) {
			this.determineSearchMode()
		}
		this.initPopList()
	}

	makeid(length) {
		var result = ""
		var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
		var charactersLength = characters.length
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength))
		}
		return result
	}

	get inputName() {
		return String(this.makeid(Math.floor(Math.random() * (100 - 1 + 1) + 1)))
	}

	get placeholder() {
		switch (this.actualSearchMode) {
			case "address":
				return this.mapService.instant("PLACEHOLDER.ADDRESS")
			case "id_building":
				return this.mapService.instant("PLACEHOLDER.ID_BUILDING")
			case "town":
				return this.mapService.instant("PLACEHOLDER.TOWN")
			case "cluster":
				return this.mapService.instant("PLACEHOLDER.CLUSTER")
			case "pop":
				return this.mapService.instant("PLACEHOLDER.POP_PCN")
		}
	}

	private determineSearchMode() {
		switch (this.actualSearchMode) {
			case "address":
				this.addressFunc()
				break
			case "id_building":
				this.idBuildingFunc()
				break
			case "town":
				this.townFunc()
				break
			case "cluster":
				// this.clusterFunc();
				break
			case "pop":
				this.initPopList()
				break
		}
	}

	private addressFunc() {
		this.autocomplete = new google.maps.places.Autocomplete(this.searchTextField.nativeElement, this.mapOptions)
		this.autocomplete.addListener("place_changed", () => {
			const p = this.autocomplete.getPlace()
			// if (this.isCoordinates()) {
			// const latlng = new google.maps.LatLng(this.address.split(',')[0], this.address.split(',')[1]);
			// this.geocoder.geocode({ location: latlng }, (res) => {
			//   this.onSelected.emit(res[0]);
			// });
			// } else {
			const matchPlace = p.formatted_address === this.searchTextField.nativeElement.value
			p.formatted_address = matchPlace ? p.formatted_address : this.searchTextField.nativeElement.value
			this.selectedPlace = p
			// }
		})
	}

	private idBuildingFunc() {
		this.selectedPlace = this.placeValue
	}

	private townFunc() {
		this.autocomplete = new google.maps.places.Autocomplete(this.searchTextField.nativeElement, this.mapCityOptions)
		this.autocomplete.addListener("place_changed", () => {
			const p = this.autocomplete.getPlace()
			const matchPlace = p.formatted_address === this.searchTextField.nativeElement.value
			p.formatted_address = matchPlace ? p.formatted_address : this.searchTextField.nativeElement.value
			this.selectedPlace = p
		})
	}

	public clusterFunc(event) {
		switch (event.value) {
			case "A&B":
				this.selectedCluster = "ab"
				break
			case "C&D":
				this.selectedCluster = "cd"
				break
			case "BI1G":
				this.selectedCluster = "agf"
				break
		}
	}

	public initPopList() {
		if (this.popsAutocompleteList && this.popsAutocompleteList.length) {
			// for(let pop of this.popsAutocompleteList){
			//   if(pop.alias){
			//     pop.nome = pop.alias
			//   }
			// }
			this.popPcnOptions = this.popControl.valueChanges.pipe(
				startWith(""),
				map(value => this._filterPopsAutocompleteListlter(value, this.popsAutocompleteList))
			)
		}
	}

	public emitPopOrPcn(e) {
		this.popControl.setValue(e.alias ? e.alias : e.nome)
		this.selectedPop = e
	}

	private _filter(value) {
		const filterValue = value.toLowerCase()
		return this.options.filter(option => option.toLowerCase().includes(filterValue))
	}

	private _filterPopsAutocompleteListlter = (value: any, list: any[]): string[] => {
		const isEntireObject = value instanceof Object
		const searchValue = isEntireObject ? value.nome || value.alias : value
		return list.filter(option => {
			const nome = option.nome ? option.nome.toLowerCase() : ""
			const alias = option.alias ? option.alias.toLowerCase() : ""
			const lowerCaseSearchValue = searchValue.toLowerCase()
			return nome.includes(lowerCaseSearchValue) || alias.includes(lowerCaseSearchValue)
		})
	}

	private isCoordinates() {
		let ret = false
		if (this.placeValue && this.placeValue.indexOf(",") >= 0) {
			const lat = this.placeValue.split(",")[0]
			const lng = this.placeValue.split(",")[1]
			if (!isNaN(lat) && !isNaN(lng)) {
				ret = true
			}
		}
		return ret
	}

	public changeSearchMode(newSearchMode) {
		this.reset(true)
		this.onSwitchSearchMode.emit(newSearchMode)
	}

	search() {
		switch (this.actualSearchMode) {
			case "address":
				this.onSelectedAddress.emit(this.selectedPlace)
				break
			case "id_building":
				this.selectedPlace = this.placeValue
				this.onSelectedId.emit(this.selectedPlace)
				break
			case "town":
				this.onSelectedCity.emit(this.selectedPlace)
				break
			case "cluster":
				this.onSelectedCluster.emit(this.selectedCluster)
				break
			case "pop":
				const pop = this.mapService.popToMarker(
					this.selectedPop,
					pageConfiguration[this.mapService.activePayload].icons.pop_standard,
					pageConfiguration[this.mapService.activePayload].icons.pop_smaller
				)
				this.onSelectedPop.emit(pop)
				break
		}
	}

	reset(fromInside = false) {
		this.placeValue = null
		this.selectedCluster = null
		this.selectedPop = null
		this.myControl.setValue("")
		this.popControl.setValue("")
		if (fromInside) {
			this.onReset.emit()
		}
	}
}
